// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","container":"breadcrumbs-pdp_container__gw97n"};